export default function Mission() {
  return (
    <section id="mission" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="max-w-4xl mx-auto text-center">
          <p className="text-sm text-gray-500 mb-6 tracking-wider">MISSION</p>
          <h2 className="text-3xl md:text-5xl font-bold text-gray-900 mb-8 leading-tight">
            讓資源走向真正需要的人<br />
            讓潛力轉化為公共價值
          </h2>
          <p className="text-base md:text-lg text-gray-600 leading-relaxed mb-6">
            少華獎不只是獎助金,更是一個長期支持體系,結合教育、企業與社會資源,協助青年穩定學習、培養能力、建立信心,並在未來回饋社會、幫助更多人。
          </p>
          <div className="flex flex-col md:flex-row md:inline-flex items-center gap-3 mt-8">
            <div className="flex items-center gap-2 px-5 py-2.5 bg-[#F5F1E8] rounded-full">
              <i className="ri-user-heart-line text-[#F4A261] text-xl w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm font-medium text-gray-700">受助者</span>
            </div>
            <i className="ri-arrow-right-line md:ri-arrow-right-line ri-arrow-down-line text-gray-400"></i>
            <div className="flex items-center gap-2 px-5 py-2.5 bg-[#F5F1E8] rounded-full">
              <i className="ri-seedling-line text-[#F4A261] text-xl w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm font-medium text-gray-700">成長者</span>
            </div>
            <i className="ri-arrow-right-line md:ri-arrow-right-line ri-arrow-down-line text-gray-400"></i>
            <div className="flex items-center gap-2 px-5 py-2.5 bg-[#F5F1E8] rounded-full">
              <i className="ri-hand-heart-line text-[#F4A261] text-xl w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm font-medium text-gray-700">貢獻者</span>
            </div>
            <i className="ri-arrow-right-line md:ri-arrow-right-line ri-arrow-down-line text-gray-400"></i>
            <div className="flex items-center gap-2 px-5 py-2.5 bg-[#F5F1E8] rounded-full">
              <i className="ri-compass-3-line text-[#F4A261] text-xl w-5 h-5 flex items-center justify-center"></i>
              <span className="text-sm font-medium text-gray-700">領航者</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}